import { createReducer, on, Action } from '@ngrx/store';
import * as unitsActions from '../actions/units.actions';
import { UnitApiModel } from 'app/models/units-api.model';

export interface State {
  units: UnitApiModel[];
  isLoading: boolean;
  isReady: boolean;
}

export const initialState: State = {
  units: [],
  isLoading: false,
  isReady: false,
};

const featureReducer = createReducer(
  initialState,
  on(unitsActions.loadUnits, (state: State) => ({
    ...state,
    isLoading: true,
  })),
  on(unitsActions.loadUnitsSuccess, (state: State, { response }) => ({
    ...state,
    isLoading: false,
    isReady: true,
    units: response,
  })),
  on(unitsActions.resetUnits, (state: State) => initialState)
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
